import { shallowEqual, useSelector } from 'react-redux';
export function useSonarSelector(selectorFn, equalityFn) {
    return useSelector(selectorFn, equalityFn);
}
export function useSonarShallowSelector(selectorFn) {
    return useSonarSelector(selectorFn, shallowEqual);
}
